
import React, { useEffect } from 'react';
import { useReceivablesContext } from '../context/receivables_context';
import '../style/Receivable.css';
import loadingImage from '../images/preloader.gif';

const Receivable = () => {
  const {
    fetchReceivables,
    receivables,
    isLoading,
  } = useReceivablesContext();

  useEffect(() => {
    fetchReceivables();
  }, []);

  const handleMouseEnter = (event, payments) => {
    console.log('Hovered over payments:', payments);
  };

  const handleMouseLeave = () => {
    // Hide tooltip logic here (if needed)
  };

  const handlePayButtonClick = (person, e) => {
    e.stopPropagation();
    console.log('Clicked Pay for:', person.name);
    // Payment modal logic goes here
  };

  return (
    <div className="receivable-page">
      {isLoading ? (
        <div className="loader-container">
          <img src={loadingImage} alt="Loading..." className="loader-img" />
        </div>
      ) : (
        <div className="receivable-container">
          {Array.isArray(receivables) && receivables.length > 0 ? (
            <div className="receivables-list">
              {receivables.map((person) => {
                const {
                  name,
                  phone,
                  user_image_from_s3,
                  rbtotal,
                  id,
                  rbpaid,
                  receipts,
                  payments,
                  group_id,
                  subscriber_id,
                  group_subscriber_id,
                  group_account_id,
                  auct_date,
                  group_name,
                  unique_id,
                  rbdue,
                  pbdue,
                } = person;

                return (
                  <article className="receivable" key={unique_id}>
                    <img
                      src={user_image_from_s3 || 'default-image.jpg'}
                      alt={name}
                      className="receivable-img"
                      onError={(e) => {
                        e.target.src = 'default-image.jpg';
                      }}
                    />
                    <div className="receivable-info">
                      <h4>{name}</h4>
                      <p>{phone}</p>
                      <p>Group Name: {group_name}</p>
                      <p>Auction Date: {auct_date}</p>
                    </div>
                    <div className="receivable-financials">
                      <p>Receivable Due: ₹{rbtotal}</p>
                      <p
                        className="receivable-paid"
                        onMouseEnter={(event) => handleMouseEnter(event, payments)}
                        onMouseLeave={handleMouseLeave}
                      >
                        Receivable Paid: ₹{rbpaid}
                      </p>
                      <h4>Receivable Balance: ₹{rbdue}</h4>
                      <p>Payable Advance: ₹{pbdue}</p>
                      <button onClick={(e) => handlePayButtonClick(person, e)}>Pay</button>
                    </div>
                  </article>
                );
              })}
            </div>
          ) : (
            <div className="empty-message">No receivables to collect.</div>
          )}
        </div>
      )}
    </div>
  );
};

export default Receivable;








// import React, { useEffect, useState } from 'react';
// import { API_BASE_URL } from '../utils/apiConfig';
// import { useUserContext } from '../context/user_context';
// import ReceivablesList from '../components/ReceivablesList';
// import '../style/Receivable.css';

// const Receivables = () => {
//     const { user } = useUserContext(); // Context to fetch user information
//     const [isLoading, setIsLoading] = useState(false);
//     const [receivables, setReceivables] = useState([]);
//     const [filteredCount, setFilteredCount] = useState(0);
//     const [region, setRegion] = useState([]);

//     // Common headers for API calls
//     const headers = {
//         'Authorization': `Bearer ${user?.results?.token}`,
//         'Content-Type': 'application/json',
//     };

//     // Fetch receivables data from the API
//     const fetchReceivables = async () => {
//         try {
//             setIsLoading(true);
//             const apiUrl = `${API_BASE_URL}/receivables`;
//             const response = await fetch(apiUrl, { method: 'GET', headers });

//             if (!response.ok) {
//                 throw new Error('Failed to fetch receivables data.');
//             }
//             const fetchedReceivables = await response.json();
//             setReceivables(fetchedReceivables.results.receivablesResult || []);
          
//         } catch (error) {
//             console.error('Error fetching receivables:', error.message);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     // Fetch areas of business data from the API
//     const loadAreasOfBusiness = async () => {
//         try {
//             setIsLoading(true);
//             const apiUrl = `${API_BASE_URL}/aob/all`;
//             const response = await fetch(apiUrl, { method: 'GET', headers });

//             if (!response.ok) {
//                 throw new Error('Failed to fetch areas of business.');
//             }
//             const data = await response.json();
//             setRegion(data.results || []);
//             console.log('Fetched regions:', data.results);
//         } catch (error) {
//             console.error('Error fetching areas of business:', error.message);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     // Refresh receivables when triggered
//     const refreshReceivables = () => {
//         fetchReceivables();
//     };

//     // Initial data fetch
//     useEffect(() => {
//         if (user?.results?.token) {
//             fetchReceivables();
//             loadAreasOfBusiness();
//         }
//     }, [user]);

//     // Callback to update the filtered count
//     const handleFilteredCount = (count) => {
//         setFilteredCount(count);
//     };

//     // Main container styles
//     const mainContainerStyle = {
//         minHeight: '100vh',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//     };

//     return (
//         <div style={mainContainerStyle}>
//             {isLoading ? (
//                 <p>Loading...</p>
//             ) : receivables.length > 0 ? (
//                 <section className="receivablecontainer">
//                     <h3>Receivables List ({filteredCount})</h3>
//                     <ReceivablesList
//                         receivables={receivables}
//                         region={region}
//                         onFilteredCount={handleFilteredCount}
//                         refreshReceivables={refreshReceivables}
//                     />
//                 </section>
//             ) : (
//                 <section className="receivablecontainer">
//                     <h3>No Receivable Data Available</h3>
//                 </section>
//             )}
//         </div>
//     );
// };

// export default Receivables;
